import { service } from '@ember/service';
import Component from '@glimmer/component';
import type FlowModel from 'garaje/models/flow';
import type SignInFieldActionModel from 'garaje/models/sign-in-field-action';
import type { FieldChangeset } from 'garaje/pods/visitors/entry/controller';
import type StateService from 'garaje/services/state';

interface EntryFieldsComponentSignature {
  Args: {
    flow: FlowModel;
    fieldsDisabled: boolean;
    locality: unknown;
    userDataChangeset: FieldChangeset[];
    fieldIdPrefix: string;
    doSearch: () => void;
    setHostAndUserData: () => void;
    updateUserDataField: () => void;
    updateLocality: () => void;
  };
}

export default class EntryFieldsComponent extends Component<EntryFieldsComponentSignature> {
  @service declare state: StateService;

  get hasAcccessToMultipleHostsFeature(): boolean {
    return !!this.state.features?.canAccessMultipleHosts;
  }

  get renderableFieldChangesets(): FieldChangeset[] {
    return this.args.userDataChangeset.filter((fieldChangeset) => {
      if (fieldChangeset.isTopLevel || fieldChangeset.isTopLevel === undefined) {
        return true;
      }

      const action = (<SignInFieldActionModel[]>fieldChangeset.actionableSignInFieldActions?.content)[0];

      // Do not attempt to automatically async fetch related signInField
      // If signInField record isn't already fulfilled, it will probably not load
      const isApplicableAction =
        action && action.belongsTo('signInField').value() && action.belongsTo('signInField').id();

      if (!isApplicableAction) {
        return false;
      }

      const changesetParent = this.args.userDataChangeset.find(
        (changeset) => changeset.id === action.belongsTo('signInField').id(),
      );

      return changesetParent && changesetParent.value === action.dropdownOption?.value;
    });
  }
}
